// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timed-notification{position:absolute;left:20px;bottom:20px;z-index:99}
`, "",{"version":3,"sources":["webpack://./src/components/Home/uiComponents/timedNotification.css"],"names":[],"mappings":"AAAA,oBACI,iBAAkB,CAClB,SAAU,CACV,WAAY,CACZ,UAAW","sourcesContent":[".timed-notification {\n    position: absolute;\n    left: 20px;\n    bottom: 20px;\n    z-index: 99;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
